import { fg } from '@atlassian/jira-feature-gating';

export const jiraEnableClassificationControlEnforcementRelayprovider = {
	get(): boolean {
		return fg('enable_classification_control_on_issue_experiences');
	},
};

export default jiraEnableClassificationControlEnforcementRelayprovider;
